/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import classname from 'classnames';
import * as React from 'react';
import { dataSvg } from './shipping-map.data-map';

// ==============================================================================
// Interfaces
// ==============================================================================
interface IShippingMapSvgProps {
    findActiveState(state: string): boolean;
}

interface IPropSvg {
    viewBox: string;
    width: string;
    height: string;
    transform: string;
}

interface IDataSvg {
    state: string;
    d: string;
}

// ==============================================================================
/**
 * ShippingMapSvg component
 * @extends {React.PureComponent<IShippingMapSvgProps>}
 */
// ==============================================================================
class ShippingMapSvg extends React.PureComponent<IShippingMapSvgProps> {

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element {
        const propSvg: IPropSvg = {
            viewBox: '0 0 600 368',
            width: '600',
            height: '368',
            transform: 'scale(0.6205733558178752) translate(3.923913043478271, 0)'
        };

        return (
            <svg className='shipping-map-svg' viewBox={propSvg.viewBox} width={propSvg.width} height={propSvg.height}>
                <g className='shipping-map-g' transform={propSvg.transform}>
                    {dataSvg.map((path: IDataSvg, index: number) =>
                        <path
                            className={classname('shipping-map-path', this._getActiveStateClass(path.state))}
                            key={index}
                            d={path.d}
                        />
                    )}
                </g>
            </svg>
        );
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _getActiveStateClass(state: string): string | null {
        return this.props.findActiveState(state) ? 'shipping-map-path-active' : null;
    }
}

export default ShippingMapSvg;